import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ModalController, PopoverController } from '@ionic/angular';
import { tap } from 'rxjs';
import { getColors } from 'src/app/models/colors';
import { Turno } from 'src/app/models/turno';
import { LoadingService } from 'src/app/services/loading.service';
import { ScaleInUseService } from 'src/app/services/scale-in-use.service';
import { TurnoService } from 'src/app/services/turno/turno.service';
import { PopoverSelectColorComponent } from 'src/app/shared/components/popover-select-color/popover-select-color.component';
import { calculeHoursShift } from 'src/app/shared/utils';

@Component({
  selector: 'turno-item',
  templateUrl: './turno-item.component.html',
  styleUrls: ['./turno-item.component.scss'],
})
export class TurnoItemComponent implements OnInit {
  @Input() isInput!: boolean;
  @Input() turno!: Turno;
  @Output() FormEmitter: EventEmitter<boolean> = new EventEmitter<boolean>();
  colorTurno!: string;
  active!: boolean;

  isEdit: boolean = false;

  formGroup!: FormGroup;

  colorSelected = '#E54997';
  h1!: string;
  h2!: string;
  turnoName!: string;

  isSaving = false;

  constructor(
    private turnoService: TurnoService,
    private modalCtrl: ModalController,
    private loadingCtrl: LoadingService,
    private popoverCtrl: PopoverController,
    private scaleInUse: ScaleInUseService
  ) {}

  ngOnInit() {
    if (this.turno) {
      this.h1 = this.turno.horaInicio;
      this.h2 = this.turno.horaFim;
      this.colorTurno = this.turno.cor || '#1FBAA4';
      this.active = this.turno.ativo;
    }
    if (this.isInput) {
      this.createForm();
    }
  }

  createForm() {
    this.formGroup = new FormGroup({
      descricao: new FormControl(this.turno ? this.turno.descricao : '', [
        Validators.required,
        Validators.maxLength(10),
      ]),
      sigla: new FormControl(this.turno ? this.turno.sigla : '', [
        Validators.required,
        Validators.maxLength(4),
      ]),
      cor: new FormControl(this.turno ? this.turno.cor : '#1FBAA4', [
        Validators.required,
      ]),
      ativo: new FormControl(this.turno ? this.turno.ativo : true, [
        Validators.required,
      ]),
      horaInicio: new FormControl(
        this.turno ? this.turno.horaInicio : '00:00',
        [Validators.required]
      ),
      horaFim: new FormControl(this.turno ? this.turno.horaFim : '00:00', [
        Validators.required,
      ]),
    });
    this.colorSelected = '#1FBAA4';
    this.scaleInUse
      .getColorsSelected()
      .pipe(
        tap((usedHexColors) => {
          // Assuming r (usedHexColors) is now an array of hex strings
          const allSystemHexColors = this.getAllColors(); // this.getAllColors() still calls the updated getColors()
          const availableHexColors = allSystemHexColors.filter(
            (hex) => !usedHexColors.includes(hex)
          );
          let colorToUse = '#1FBAA4'; // Default color if none are available or list is empty
          if (availableHexColors.length > 0) {
            colorToUse = availableHexColors[0];
          }
          this.colorSelected = colorToUse;
          if (!this.isEdit) {
            this.formGroup.patchValue({ cor: colorToUse });
          }
        })
      )
      .subscribe();

    if (this.isEdit) {
      this.colorSelected = this.turno.cor!;
    }
  }

  getAllColors() {
    return getColors();
  }

  calcShow() {
    return calculeHoursShift(this.h1, this.h2);
  }

  calcInput() {
    return calculeHoursShift(
      this.formGroup.value.horaInicio,
      this.formGroup.value.horaFim
    );
  }

  submit() {
    if (this.formGroup.invalid) {
      if (this.formGroup.get('descricao')?.hasError('maxlength')) {
        this.loadingCtrl.presentToast(
          'Descrição deve ter no máximo 10 caracteres.'
        );
      } else if (this.formGroup.get('sigla')?.hasError('maxlength')) {
        this.loadingCtrl.presentToast('Sigla deve ter no máximo 4 caracteres.');
      } else {
        this.loadingCtrl.presentToast(
          'Por favor, preencha todos os campos corretamente.'
        );
      }
      return;
    }
    if (this.calcInput() == '0h' || this.calcInput() == '0h00') {
      this.loadingCtrl.presentToast('Horas invalidas!');
      return;
    }
    this.isSaving = true;
    console.log('PASSED');
    // TODO: ver porque ao editar esta duplicando o turno.
    console.log(this.isEdit, 'in edditing');
    if (!this.isEdit) {
      this.turnoService
        .criaTurno({
          ...this.formGroup.value,
        })
        .pipe(
          tap(() => {
            this.isSaving = false;
            this.loadingCtrl.presentToast('Turno criado com sucesso');
            this.formGroup.reset();
            this.createForm();
            this.isInput = false;
            this.FormEmitter.emit(false);
            // this.modalCtrl.dismiss()
          })
        )
        .subscribe();
    } else {
      this.turnoService
        .atualizarTurno(this.turno.id, {
          ...this.formGroup.value,
        })
        .pipe(
          tap((res) => {
            this.isSaving = false;
            this.loadingCtrl.presentToast('Turno editado com sucesso');
            this.isEdit = false;
            this.isInput = false;
            this.formGroup.reset();
            this.turno = res;
            this.scaleInUse.alertarFecharSetores();
            // this.modalCtrl.dismiss()
          })
        )
        .subscribe();
    }
  }

  setEditMode() {
    this.isEdit = true;
    this.isInput = true;
    this.createForm();
  }

  cancel() {
    if (this.isEdit) {
      this.isEdit = false;
      this.isInput = false;
      this.formGroup.reset();
      return;
    }
    this.formGroup.reset();
    this.createForm();
    this.isInput = false;
    this.FormEmitter.emit(false);
  }

  deleteTurno() {
    this.loadingCtrl.presentAlertConfirm(
      'Excluir Turno?',
      '',
      'Deseja realmente excluir este Turno? Ao confirmar a exclusão, ele será removido de todos os meses. Se optar por inativá-lo, ele permanecerá registrado, mas não será permitido a utilização nesta escala mesmo que em nos outros meses.',
      () => {
        this.turnoService.deletarTurno(this.turno.id);
      }
    );
  }

  async openPopover(event: any) {
    const popover = await this.popoverCtrl.create({
      component: PopoverSelectColorComponent,
      side: 'top',
      mode: 'ios',
      event,
      componentProps: {
        scaleId: this.scaleInUse.getEscalaPeriodoId()!,
        isSector: false,
      },
    });

    popover.present();

    popover.onDidDismiss().then((r) => {
      if (r.data != undefined) {
        this.colorSelected = r.data;
        this.formGroup.patchValue({ cor: r.data });
      }
    });
  }
}
